import React, { useEffect, useState } from "react";
import { isEmpty, get, forEach } from "lodash";
import { Button, notification } from "antd";
import { DoubleRightOutlined } from "@ant-design/icons";

// Including local dependencies
import dashboardService from "@services/dashboard.service";
import sessionService from "@services/session.service";
import CalenderView from "./components/calenderView/calenderView";
import PatientProfileReport from "./components/patientProfileReport/patientProfileReport";
import { appInsights, reactPlugin, withAITracking } from "../../appInsights";
import LayoutOfDashboard from "@layout/defaultForDashboard";
import PopulationInsight from "./components/populationInsight/populationInsight";
import PowerBiEmbed from "../../components/power-bi-report";
import InpatientManagementReport from "./components/inpatientReport/inpatientManagementReport";
import GenericTableReport from "./components/GenericTableReport/GenericTableReport";
import COReport from "./components/COReport/COReport";
import CadenceReport from "./components/CadenceReport/CadenceReport";
// import HospitalMapping from "@components/hospitalMapping/hospitalMapping";
import HospitalListAndCmPage from "./components/hospitalListAndCM/hospitalListAndCM";
import HighCostPatient from "@components/high-cost-patient-report/highCostPatientReport";
// import { pageMode } from "@components/hospitalMapping/hospitalMapping";
import { useHospitalMappingStore } from "@stores/useHospitalMappingStore";
// import { useGlobalInformationStore } from "@stores/global_informationStore";
import { HOSPITAL_LIST_AND_CM_USER_OPENED_FROM, dashBoardReportPageMapping } from "@utils/constants";
import DataQualityDashboard from "./components/dataQualityDashboard/dataQualityDashboard";

import DashboardNavigation from "./components/dasboardNavigation/navigation";
import { LeftNav } from "./components/dasboardNavigation/leftnav";
import "./dashboard.scss";
import Icon from "@assets/icon_config";
import { useDashboardStore } from "@stores/dashboardStore";
import StarComponent from "./components/dasboardNavigation/star";
import classNames from "classnames";
import MeasureReport from "./components/qualityMeasureReport/measures";
import DataQualityReport from "./components/dataQualityReport/dataQualityReport";
import ChronicBreakdownReport from "./components/chronicBreakdownReport/chronicBreakdown";

const Dashboard = () => {
  const selectedReport = useDashboardStore((state) => state.selectedReport);
  const setSelectedReport = useDashboardStore((state) => state.setSelectedReport);
  const accessToken = useDashboardStore((state) => state.accessToken);
  const setaccessToken = useDashboardStore((state) => state.setaccessToken);
  const embedURL = useDashboardStore((state) => state.embedURL);
  const setEmbedURL = useDashboardStore((state) => state.setEmbedURL);
  const responseOfApi = useDashboardStore((state) => state.responseOfApi);
  const reportList = useDashboardStore((state) => state.reportList);
  const setResponse = useDashboardStore((state) => state.setResponse);
  const setReportList = useDashboardStore((state) => state.setReportList);
  const selectedNavigation = useDashboardStore((state) => state.selectedNavigation);
  const hospitalMappingEditModeOpenedFrom = useHospitalMappingStore((state) => state.hospitalMappingEditModeOpenedFrom);

  const [open, setOpen] = useState(false);
  const [hideOverlayModal, sethideOverlayModal] =  useState(false);

  // static color of the brands, later on need to make them dynamic
  const colorOfBrand = ["#2191b6", "#EF6D2A"];

  useEffect(() => {
    console.log("Dashboard.useEffect");
    /**
     * Function to call dashboard service and get the data of a specific report
     * @param reportId : Report id of the Power Bi report
     * @param workSpaceId : Workspace or group id of the Power Bi report
     */

    const fetchAccessToken = async (reportId: string, workSpaceId: string, value?: string) => {
      console.log("Dashboard.fetchAccessToken");
      dashboardService.fetchPowerBiAccessToken(reportId, workSpaceId, value).subscribe({
        next: (v) => {
          setaccessToken(get(v?.data, "data.token", null));
          setEmbedURL(get(v?.data, "data.embedURL", null));
        },
        error: (e) => {
          console.log(e);
        },
      });
    };

    if (!isEmpty(selectedReport?.reportId) && !isEmpty(selectedReport?.workspaceId)) {
      fetchAccessToken(selectedReport?.reportId, selectedReport?.workspaceId, selectedReport?.value);
    }
    
    return () => {
      setaccessToken('')
    }
  }, [selectedReport?.reportId, selectedReport?.workspaceId, setEmbedURL, setaccessToken]);

  /**
   * @param param0 function is responsible to store the time on which the report is been opened
   */
  const updateReport = ({ reportValue, isOpened }: any) => {
    console.log("Dashboard.updateReport");
    dashboardService.updateReport({ reportValue, isOpened }).subscribe({
      next: (response) => {
        const updatedLastOpen = ( response?.data?.data?.lastOpenDate).replace(" ","T") + ".000Z";
        const _responseOfApi = responseOfApi;

        forEach(_responseOfApi, (item: any) => {
          forEach(item.options, (option) => {
            forEach(option.groups, (group) => {
              forEach(get(group, "options", []), (_option) => {
                if (reportValue === _option.value) {
                  _option.lastOpenDate = updatedLastOpen;
                }
              });
            });
          });
        });

        setResponse(_responseOfApi);

        const _reportList = [...reportList];
        forEach(_reportList, (_option) => {
          if (reportValue === _option.value) {
            _option.lastOpenDate = updatedLastOpen;
          }
        });

        setReportList(_reportList);

        if (selectedReport?.value === reportValue) {
          const _selectedReport = selectedReport;
          _selectedReport.lastOpenDate = updatedLastOpen;
          setSelectedReport(_selectedReport);
        }
      },
      error: (e) => {
        console.log(e);
      },
    });
  };

  /**
   * handler for click on any report to open it
   */
  const handleReportClick = (reportDetails: any) => {
    console.log("Dashboard.handleReportClick");
    appInsights.trackPageView({ name: `${reportDetails?.title} : ${reportDetails?.value}` });
    setSelectedReport(reportDetails);
    updateReport({ reportValue: reportDetails?.value, isOpened: "Y" });
  };

  // this function decided which report we will be showing on the Dashboard
  const reportComponent = (selectedReport: any) => {
    if (get(selectedReport, "value", null) === "cmContactMatrix") {
      return <HospitalListAndCmPage />;
    } else if (
      get(selectedReport, "value", null) === "populationInsightsDental" ||
      get(selectedReport, "value", null) === "populationInsightsMedical" ||
      get(selectedReport, "value", null) === "populationInsightsVision"
    ) {
      return <PopulationInsight colorOfBrand={colorOfBrand} />;
    } else if (get(selectedReport, "value", null) === "wellbeDataProcessingReport") {
      return <DataQualityDashboard />
    } else if (get(selectedReport, "value", null) === "wellbeDataQualityReport") {
      return <DataQualityReport />
    } else if (get(selectedReport, "value", null) === "calendarViewDental" || get(selectedReport, "value", null) === "calenderView" || get(selectedReport, "value", null) === "calenderView") {
      return <CalenderView colorOfBrand={colorOfBrand} />;
    } else if (get(selectedReport, "value", null) === "patientProfileMedical") {
      return <PatientProfileReport />;
    } else if (get(selectedReport, "value", null) === "inpatientMgmt") {
      return <InpatientManagementReport />;
    } else if (get(selectedReport, "value", null) === "highcostreportMedical") {
      return <HighCostPatient/>;
    } else if (get(selectedReport, "value", null) === "mpgCOReport") {
      return <COReport selectedReport={selectedReport}/>;
    } else if (get(selectedReport, "value", null) === "mpgCadenceReport") {
      return <CadenceReport selectedReport={selectedReport}/>;
    } else if (Object.keys(dashBoardReportPageMapping).includes(get(selectedReport, "value", null))) {
      return <GenericTableReport selectedReport={selectedReport}/>;
    } 
    else if (get(selectedReport, "value", null) === "measuresReport") {
      return <MeasureReport/>;
    }
    else if (get(selectedReport, "value", null) === "ChronicReports") {
      return <ChronicBreakdownReport />;
    }
    else {
      return !isEmpty(embedURL) && !isEmpty(accessToken) ? (
        <div style={{ height: "100%" }}>
          {/* 
            PowerBi requires, embed URL with reportid, workspaceid , access token, and pageId 
            to generate the iframe url
          */}
          <PowerBiEmbed embedUrl={embedURL} reportId={selectedReport?.reportId} accessToken={accessToken} reportPageName={selectedReport?.pageId} />
        </div>
      ) : null;
    }
  };

  useEffect(() => {
    console.log("Dashboard.useEffect 2");
    appInsights.setAuthenticatedUserContext(sessionService?.getUser()?.email);
  }, []);

  const handleHideOverlay = () => {
    sethideOverlayModal(true);
  };

  const updateStarReport = ({ reportValue, isStarred }: any) => {
    console.log("Dashboard.updateStarReport");
    dashboardService.updateReport({ reportValue, isStarred }).subscribe({
      next: () => {
        if (!isEmpty(isStarred)) {

          const _responseOfApi = responseOfApi;

          forEach(_responseOfApi, (item: any) => {
            forEach(item.options, (option) => {
              forEach(option.groups, (group) => {
                forEach(get(group, "options", []), (_option) => {
                  if (reportValue === _option.value) {
                    _option.starred = isStarred;
                  }
                });
              });
            });
          });

          setResponse(_responseOfApi);

          const _reportList = [...reportList];
          forEach(_reportList, (_option) => {
            if (reportValue === _option.value) {
              _option.starred = isStarred;
            }
          });

          if (selectedNavigation?.groupTitle === "Starred") {
            const list: any[] = [];
            forEach(_reportList, (item: any) => {
              if (item.starred === "Y") {
                list.push(item);
              }
            });
            setReportList(list);
          } else {
            setReportList(_reportList);
          }

          if (selectedReport?.value === reportValue) {
            const _selectedReport = selectedReport;
            _selectedReport.starred = isStarred;
            setSelectedReport(_selectedReport);
          }

          // setStarStatus(isStarred);

          notification.success({
            message: "Success",
            description: isStarred === "Y" ? "Report Starred Successfully." : "Removed Starred Report Successfully.",
          });
        }
      },
      error: (e) => {
        console.log(e);
      },
    });
  };

  return (
    <LayoutOfDashboard noPadding={true}>
      {(open && !hideOverlayModal)&& <div className="overlay-modal"></div>}
      {isEmpty(selectedReport) ? (
        <DashboardNavigation
          handleReportClick={handleReportClick}
          handleOpenFlagOfLeftNav={() => {
            if (open === true) {
              setOpen(false);
            }
          }}
          updateReport={updateStarReport}
        />
      ) : (
        <div className="ui-dashboard__report-container">
          {/* left nav inside the report view */}
          {open && (
            <div className="ui-dashboard__report-container__navigation">
              <LeftNav
                handleButtonClick={() => {
                  setOpen(false);
                  sethideOverlayModal(false);
                }}
                handleGroupClick={() => {
                  setOpen(false);
                  setSelectedReport(null);
                }}
                open={open}
                handleHideOverlay={handleHideOverlay}
              />
            </div>
          )}
          { ((!open) && !(hospitalMappingEditModeOpenedFrom === HOSPITAL_LIST_AND_CM_USER_OPENED_FROM.Members || hospitalMappingEditModeOpenedFrom === HOSPITAL_LIST_AND_CM_USER_OPENED_FROM.memberDetailADT)) && (
            <Button
              className="ui-dashboard__report-container__profile-expand-btn"
              icon={<DoubleRightOutlined />}
              size={"middle"}
              onClick={() => {
                setOpen(true);
              }}
            />
          )}
          {/* back button for the dashboard */}
          <div
            className={classNames({
              "ui-dashboard__report-container__back-btn": true,
              "ui-dashboard__report-container__back-btn__hide": (hospitalMappingEditModeOpenedFrom === HOSPITAL_LIST_AND_CM_USER_OPENED_FROM.Members || hospitalMappingEditModeOpenedFrom === HOSPITAL_LIST_AND_CM_USER_OPENED_FROM.memberDetailADT)
            })}
          >
            <span className="ui-dashboard__report-container__back-btn__group"
             onClick={() => {
              setOpen(false);
              setSelectedReport(null);
            }}>
              <span className="ui-dashboard__report-container__back-btn__icon">
                <Icon name="back" />
              </span>
              <span> {selectedNavigation.groupTitle} / {selectedReport.title} </span>
            </span>
            {/* star button */}
            <StarComponent className="ui-dashboard__report-container__back-btn__star" starred={selectedReport?.starred} reportValue={selectedReport?.value} starFilledSize={15} starOutlinedSize={15} update={updateStarReport}/>
          </div>

          {/* report content */}

          <div className="ui-dashboard__report-container__report  custom-scroll-bar">{reportComponent(selectedReport)}</div>
        </div>
      )}
    </LayoutOfDashboard>
  );
};

export default withAITracking(reactPlugin, Dashboard);
